<template>
  <div v-if="isStayBundle" class="buybox__bundle lsg-bundle-block" 
    :class="{ 'lsg-bundle-block-active': product.bundleFirst }" 
    :data-bundle-product="product.bundleProduct"
    :data-bundle-index="product.bundleIndex"
    :data-otp-bundle-min="product.otpBundleMin"
    :data-otp-bundle-max="product.otpBundleMax"
    :data-sub-bundle-min="product.subBundleMin"
    :data-sub-bundle-max="product.subBundleMax"
    :data-product-base-price="product.productBasePrice"
    >

    <div v-if="product.subBundleProductsCount > 0" :data-bundle-min="product.subBundleMin" :data-bundle-max="product.subBundleMax" class="buybox__bundle-product-set-list lsg-bundle-product-set-list" data-lsg-bundle-product-sub-list>

      <template
        v-for="(select, selectIndex) in product.bundleProductSelect"
        :key="selectIndex"
        class="lsg-bundle-block lsg-bundle-lock-active flex"
      >
        <div
          v-for="(bundleChild, variantIndex) in select.variants"
          :key="bundleChild.id"
          class="buybox__bundle-product-wrapper option-chip lsg-bundle-product-select-wrapper"
          :data-lsg-bundle-variant-select-id="bundleChild.id"
        >
          <div class="buybox__bundle-product-flavor" :class="['flavor', bundleChild.flavor.toLowerCase().replace(/ /g, '-')].join('-')">{{ bundleChild.flavor }}</div>

          <div class="buybox__bundle-product-servings text-sm">{{ bundleChild.servings }} Servings</div>

          <div class="buybox__bundle-product-select-quantity-wrap no-quantity" :data-buybox-id="variantIndex" :max="bundleChild.inventory_policy === 'deny' && bundleChild.inventory_management != null ? bundleChild.inventory_quantity : 999" :data-price="bundleChild.price" :data-product="bundleChild.id">
            <div class="buybox__bundle-qty btn btn--solid btn--md btn--wide">
              <button type="button" aria-label="Decrease item quantity" class="buybox__bundle-qty-button" @click="decrementQuantity($event, variantIndex)">
                <svg class="icon icon--sm">
                  <use href="#minus"></use>
                </svg>
              </button>
              <input autocomplete="false" type="number" :value="cartQuantities[variantIndex] || 0" min="0" :max="bundleChild.inventory_policy === 'deny' && bundleChild.inventory_management != null ? bundleChild.inventory_quantity : 999" class="lsg-bundle-product-select-quantity-input hide" :data-price="bundleChild.price" :data-product="bundleChild.id" aria-label="quantity">
              <span>{{ cartQuantities[variantIndex] || 0 }}</span>
              <button type="button" aria-label="Increase item quantity" class="buybox__bundle-qty-button" @click="incrementQuantity($event, variantIndex)">
                <svg class="icon icon--sm">
                  <use href="#plus"></use>
                </svg>
              </button>
            </div>
            <button class="btn btn--primary btn--md btn--outline" @click="incrementQuantity($event, variantIndex)">Add</button>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script setup>
  import { toRefs, ref, nextTick } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },

    selectedVariant: {
      type: Object,
      default: null,
    },

    isSubscription: {
      type: Boolean,
      default: false, 
    },

    isStayBundle: {
      type: Boolean,
      default: false, 
    }
  });

  const { product, selectedVariant, isSubscription, isStayBundle } = toRefs(props);
  //const emit = defineEmits(['update-option']);

  const cartQuantities = ref({}); // Store quantities for each buybox

  const getTotalQuantity = () => {
    return Object.values(cartQuantities.value).reduce((sum, qty) => sum + (qty || 0), 0);
  };

  // Initialize quantity for a specific buybox
  const initializeQuantity = (buyboxId) => {
    if (!(buyboxId in cartQuantities.value)) {
      cartQuantities.value[buyboxId] = 0;
    }
  };

  const incrementQuantity = async (event, buyboxId) => {
    // Ensure buyboxId exists in cartQuantities
    initializeQuantity(buyboxId);
    
    const interval = await atcGetBundleInterval(event);
    const maxQuantity = interval === 'otp' ? product.value.otpBundleMax : product.value.subBundleMax;
    const totalQuantity = getTotalQuantity();

    // Increment quantity if below max
    if (totalQuantity < maxQuantity) {
      cartQuantities.value[buyboxId]++;
    }
    
    // Update parent class
    updateQuantityClass(event, buyboxId);
    await nextTick();
    await atcEnableValidation(event);
  }

  const decrementQuantity = async (event, buyboxId) => {
    // Ensure buyboxId exists in cartQuantities
    initializeQuantity(buyboxId);
    
    // Decrease quantity only if greater than 0
    if (cartQuantities.value[buyboxId] > 0) {
      cartQuantities.value[buyboxId]--;
    }
    
    // Update parent class
    updateQuantityClass(event, buyboxId);
    await nextTick();
    await atcEnableValidation(event);
  }

  // Update no-quantity class based on current quantity
  const updateQuantityClass = (event, buyboxId) => {
    const parent = event.target.closest('.buybox__bundle-product-select-quantity-wrap');
    if (parent) {
    if (cartQuantities.value[buyboxId] > 0) {
      parent.classList.remove('no-quantity');
    } else {
      parent.classList.add('no-quantity');
    }
  }
  }

  const atcGetBundleInterval = async (event) => {
    if(isSubscription.value) {
      return 'sub';
    } else if(!isSubscription.value) {
      return 'otp';
    }

    return 'err';
  }

  const atcGetContentBlock = async (event) => {
    const contentBlock = event.target.closest('.buybox__content');
    return contentBlock;
  }

  const atcGetBundleBlock = async (event) => {
    const contentBlock = event.target.closest('.buybox__content');
    const bundleBlock = contentBlock ? contentBlock.querySelector('.buybox__bundle') : null;
    return bundleBlock;
  }

  const atcGetBundleQuantity = async (event) => {
    // Gets sum of all the fields with cartQuantities
    const totalQuantity = getTotalQuantity();
    return totalQuantity;
  };

  const atcEnableValidation = async (event) => {
    const contentBlock = event.target.closest('.buybox__content');
    const bundleBlock = await atcGetBundleBlock(event);
    const addToCartButtons = contentBlock ? document.querySelectorAll('.buybox__atc .lsg-bundle-submit-button') : null;
    const bundleQuantity = await atcGetBundleQuantity(event);
    const interval = await atcGetBundleInterval(event);
    
    const bundleMin = (interval == 'otp' ? product.value.otpBundleMin : product.value.subBundleMin);
    const bundleMax = (interval == 'otp' ? product.value.otpBundleMax : product.value.subBundleMax);
    
    const quantityToAdd = bundleMin - bundleQuantity;

    //checkout button enable/disable
    addToCartButtons.forEach((addToCartButton) => {
      const addToCartText = addToCartButton.querySelector('.lsg-bundle-submit-button-atc-text');
      const addMoreText = addToCartButton.querySelector('[data-lsg-bundle-submit-button-add-more-text]');
      const addMoreQuantity = addToCartButton.querySelector('[data-lsg-bundle-submit-button-add-more-quantity]');

      if (bundleQuantity >= bundleMin && (bundleQuantity <= bundleMax || bundleMax < bundleMin)) {
        addToCartButton.removeAttribute('disabled');
        addToCartText.classList.remove('hide');
        addMoreText.classList.add('hide');
        bundleBlock.classList.add('bundle-checkout-enabled');
      } else {
        addToCartButton.setAttribute('disabled', '');
        addToCartText.classList.add('hide');
        addMoreText.classList.remove('hide');
        addMoreQuantity.innerHTML = quantityToAdd;
        bundleBlock.classList.remove('bundle-checkout-enabled');
      }
    });

    await updateBundlePrice(event);
  }

  const updateBundlePrice = async (event) => {
    //updates OTP/Sub pricing
    const contentBlock = await atcGetContentBlock(event);
    const bundleBlock = await atcGetBundleBlock(event);

    const otpPriceEls = contentBlock ? document.querySelectorAll('.otp__input-price') : null;
    const otpPriceDiscountEl = bundleBlock ? document.querySelector('.otp__input') : null;
    const otpDiscountPriceEls = contentBlock ? document.querySelectorAll('.otp__input-price-discounted') : null;
    const subPriceEls = contentBlock ? document.querySelectorAll('.subscription__input-price') : null;
    const curPriceEls = contentBlock ? document.querySelectorAll('.lsg-bundle-submit-button-atc-text') : null;
    const frequency = contentBlock.querySelector('.subscription__input');
    const productList = contentBlock.querySelector('.lsg-bundle-product-set-list');
    const productBasePrice = parseInt(bundleBlock.dataset.productBasePrice);

    const interval = await atcGetBundleInterval(event);
    let otpSubtotal = 0;
    let otpSubtotalDiscounted = 0;
    let subSubtotal = 0;

    if(productList && interval) {
        const discountType = frequency.dataset.discountType;
        const discountValue = frequency.dataset.discountValue;
        const otpDiscountValue = otpPriceDiscountEl.dataset.otpDiscountValue; // hardcoded 15% from data

        productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(subProductInput, index){
            let quantity = parseInt(subProductInput.value);
            let price = parseInt(subProductInput.dataset.price);
            let discount = 0;
            let otpDiscount = 0;
            switch(discountType){
                case 'percentage':
                    discount = (price * parseInt(discountValue)) / 100;
                    otpDiscount = Math.floor((price * parseInt(otpDiscountValue).toFixed(0)) / 100);
                    break;
                case 'fixed_amount':
                    discount = parseInt(discountValue);
                    break;
                case 'price':
                    discount = price - parseInt(discountValue);
                    break;
            }
            subSubtotal = subSubtotal + (quantity * (price - discount.toFixed(0)));
            otpSubtotal = otpSubtotal + (quantity * price);
            otpSubtotalDiscounted = otpSubtotalDiscounted + (quantity * (price - otpDiscount.toFixed(0)));
        });
    }

    if (otpSubtotal > 0) {
      otpSubtotal = otpSubtotal + productBasePrice;
    }

    if (subSubtotal > 0) {
        const discountType = frequency.dataset.discountType;
        const discountValue = frequency.dataset.discountValue;
        let discount = 0;
        switch(discountType){
            case 'percentage':
                discount = (productBasePrice * parseInt(discountValue)) / 100;
                break;
            case 'fixed_amount':
                discount = parseInt(discountValue);
                break;
                case 'price':
                discount = productBasePrice - parseInt(discountValue);
                break;
            }
        if(discount < 0) { discount = 0; }
        subSubtotal = subSubtotal + (productBasePrice - discount.toFixed(0));
    }

    const formatPrice = (price) => {
      return window.formattedPrice(price/100)
    }

    otpPriceEls.forEach(function(el){
      (otpSubtotal > 0) ? (el.innerHTML = formatPrice(otpSubtotal)) : (el.innerHTML = '');
    });

    otpDiscountPriceEls.forEach(function(el){
      (otpSubtotalDiscounted > 0) ? (el.innerHTML = formatPrice(otpSubtotalDiscounted)) : (el.innerHTML = '');
    });

    subPriceEls.forEach(function(el){
      (subSubtotal > 0) ? (el.innerHTML = formatPrice(subSubtotal)) : (el.innerHTML = '');
    });

    curPriceEls.forEach(function(el){
        (otpSubtotalDiscounted > 0) ? (el.querySelector('.button-otp-text').innerHTML = "Add to Bag - " + formatPrice(otpSubtotalDiscounted)) : (el.innerHTML = '');
        (subSubtotal > 0) ? (el.querySelector('.button-sub-text').innerHTML = "Add to Bag - " + formatPrice(subSubtotal)) : (el.innerHTML = '');
    });
  }
</script>
